import axiosInstance from "../../config/axios-config";

export const productDraft = row => ({price: String(row.price ?? ""), quantity: String(row.quantity ?? ""),
    discount: String(row.discount ?? ""), active: !!row.active});

export function validateProductDraft(draft) {
    const numeric = value => String(value).trim() !== "" && Number.isFinite(Number(value));
    const errors = {};
    if (!numeric(draft.price) || Number(draft.price) <= 0) errors.price = "ProductsInvalidPrice";
    if (!numeric(draft.quantity) || !Number.isInteger(Number(draft.quantity)) || Number(draft.quantity) < 0 ||
        Number(draft.quantity) > 2147483647) errors.quantity = "ProductsInvalidStock";
    if (!numeric(draft.discount) || Number(draft.discount) < 0 || Number(draft.discount) > 100)
        errors.discount = "ProductsInvalidDiscount";
    return errors;
}

export async function saveProduct(row, draft, options) {
    const url = `/api/v1/product_tenants/${row.productTenantId}`;
    const {data: latest} = await axiosInstance.get(url, options);
    if (options.signal.aborted) return null;
    if (latest?.productTenantId !== row.productTenantId || !latest.currency || !Number.isFinite(latest.productPrice) ||
        (row.tenantId && latest.tenantId !== row.tenantId)) throw new Error("ProductsIdentityMismatch");
    // The list omits promotion. Refresh the complete listing to preserve untouched fields in the full PUT.
    const payload = {productPrice: latest.productPrice, quantity: latest.quantity, discount: latest.discount,
        active: latest.active, inStock: latest.inStock, currency: latest.currency, endDate: latest.endDate ?? null,
        promotion: latest.promotion ?? null};
    for (const field of ["price", "quantity", "discount", "active"]) {
        const value = field === "active" ? draft[field] : Number(draft[field]);
        const original = field === "active" ? !!row.active : row[field];
        if (value !== original) payload[field === "price" ? "productPrice" : field] = value;
    }
    const {data} = await axiosInstance.put(url, payload, options);
    const saved = data?.data;
    if (saved?.productTenantId !== row.productTenantId || !saved.currency || !Number.isFinite(saved.productPrice) ||
        !Number.isInteger(saved.quantity) || !Number.isFinite(saved.discount) || typeof saved.active !== "boolean")
        throw new Error("ProductsSaveUnconfirmed");
    return {...row, ...saved, price: saved.productPrice};
}

export async function removeProduct(row, options) {
    await axiosInstance.delete(`/api/v1/product_tenants/${row.productTenantId}`, options);
}
